var _defs, _g, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMismatchCloudDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-cloud",
    style: {
      height: "fit-content"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 724.119 181.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cloud{fill:#f0f7fa;}.title-cloud{fill:#002b49; font-size: 24px !important;}.title-cloud,.subtitle-cloud{font-size:40px;font-family:Avenir\n            Heavy, !important;font-weight:800;}.subtitle-cloud{fill:#006ebb;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.995, 0.105, -0.105, 0.995, -231.824, -182.464)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cloud",
    d: "M21239.824,15164.332a36.77,36.77,0,0,1-34.18-5.225,28.657,28.657,0,1,1-4.937-54.357,36.714,36.714,0,0,1,60.625,10.412,28.612,28.612,0,0,1,7.512,1.418,28.171,28.171,0,0,1,50.02,1.408,16.6,16.6,0,1,1-1.16,26.594,28.189,28.189,0,0,1-32.527,12.539,28.666,28.666,0,0,1-45.352,7.211Z",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, -22376.211, -12571.849)"
  }))), /*#__PURE__*/React.createElement("text", {
    fill: "#002b49",
    style: {
      fontSize: 24,
      fontFamily: "Avenir Heavy",
      fontWeight: 800
    },
    transform: "translate(167.119 109.637)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -75,
    y: -10
  }, "LEIDER IST ES HIER KEIN MATCH GEWORDEN"))), /*#__PURE__*/React.createElement("text", {
    fill: "#006ebb",
    style: {
      fontSize: 40,
      fontFamily: "Avenir Heavy",
      fontWeight: 800
    },
    transform: "translate(162.119 61.637)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: -95,
    y: 0
  }, "LEIDER IST ES EIN MISMATCH!"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMismatchCloudDe);
export default __webpack_public_path__ + "static/media/mismatch_cloudDE.7391866c2276e3de90d0aa00e9605775.svg";
export { ForwardRef as ReactComponent };